import request from '@/utils/request'
import axios from 'axios'

export function queryCarByUserId(query) {
    let r = request({
        url: 'car/queryCarByUserId',
        method: 'GET',
        params: query
    })
    console.log(r)
    return r;
}

export function getGoodsDetail(goodsId) {
    let r = request({
        url: 'car/getGoodsDetail',
        method: 'GET',
        params:{goodsId}
    })
    console.log(r)
    return r;
}
export function removeCarByCondition(data) {
  return request({
    url: '/car/removeGoodsCar',
    method: 'Post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/shoppingBag.js